import React, { useEffect } from 'react';
import { Icon } from '@app/src/common/Icon';
import {
  Wrapper,
  Main,
  SubMain,
  Item,
  IconExpand
} from './styled';
import { isClientEnv } from '@app/src/utils/validations';
import { COLORS } from '@app/src/ui';

interface Props {
  className?: string;
  itemInicio?: boolean;
  navRef?: any;
  isFixed?: boolean;
  isFixedHeader?: boolean;
  showIcons?: boolean;
}

const isClient = isClientEnv();

export const NavBar: React.FC<Props> = ({
  className,
  navRef,
  isFixed,
}) => {
  useEffect(() => {
    const header = document.getElementById('header');
    const sectionId = isClient && window.location.href.split('#')[1];
    if (isClient) {
      if (sectionId === 'desplegados' || sectionId === 'economicos') {
        const id = sectionId.replace('#', '');
        const content = document.getElementById(id);
        window.scrollTo(0, content.offsetTop - header.offsetHeight);
      }
    }
  }, []);

  const handleClickWrapper = (e) => {
    if (isClient) {
      e.preventDefault();
      const element = e.target;
      const link = element.dataset.link;
      const id = link && link.replace('#', '');

      if (link) {
        pushDatalayer(element.textContent, id);
        if (link[0] === '#') {
          const elementTo = document.getElementById(id);
          window.scrollTo(0, elementTo && elementTo.offsetTop);
          (window as any).location.href = `/${link}`;
        } else {
          (window as any).location.href = link;
        }
      }
    }
  };

  const pushDatalayer = (service: string, alias: string) => {
    if (isClient && (window as any).dataLayer) {
      (window as any).dataLayer.push({
        'event': 'EVClasificados',
        'eventCategory': 'MenuClasificados',
        'eventAction': service,
        'eventLabel': alias,
        'eventValue': 1
      });
    }
  };

  return (
    <Wrapper
      className={className}
      ref={navRef}
      isFixed={isFixed}
      onClick={handleClickWrapper}
    >
      <Main>
        <li>
          <Item href="#" data-link="">
            Avisos impresos
            <IconExpand>
              <Icon data-name="icon-expand-more" fill={COLORS.BLACK} width="12" height="12" />
            </IconExpand>
          </Item>
          <SubMain>
            <li>
              <Item
                href="#economicos"
                data-link="#economicos">avisos económicos</Item>
            </li>
            <li>
              <Item
                href="#desplegados"
                data-link="#desplegados">avisos desplegados</Item>
            </li>
          </SubMain>
        </li>
      </Main>
    </Wrapper>
  )
};

NavBar.displayName = 'NavBar';
